import { http } from '@/api/http'
import type { Order } from '@/lib/pos-types'
import { normalizeOrder, unwrapList, unwrapSingle } from '@/api/normalizers'

type OrdersListParams = {
  active?: boolean
  since?: string
  limit?: number
  offset?: number
  includeItems?: boolean
}

export const ordersApi = {
  list: async (params?: OrdersListParams): Promise<Order[]> => {
    const q = new URLSearchParams()
    if (params?.active !== undefined) q.set('active', params.active ? '1' : '0')
    if (params?.since) q.set('since', params.since)
    if (typeof params?.limit === 'number') q.set('limit', String(params.limit))
    if (typeof params?.offset === 'number') q.set('offset', String(params.offset))
    if (params?.includeItems !== undefined) q.set('include_items', params.includeItems ? '1' : '0')

    const url = q.toString() ? `/orders?${q.toString()}` : '/orders'
    const res = await http.get<unknown>(url)
    return unwrapList(res.data).map(normalizeOrder)
  },
  create: async (payload: unknown): Promise<Order> => {
    const res = await http.post<unknown>('/orders', payload)
    return normalizeOrder(unwrapSingle(res.data))
  },
  update: async (orderId: string, payload: unknown): Promise<Order> => {
    const res = await http.patch<unknown>(`/orders/${encodeURIComponent(orderId)}`, payload)
    return normalizeOrder(unwrapSingle(res.data))
  },
  delete: async (orderId: string): Promise<void> => {
    await http.delete(`/orders/${encodeURIComponent(orderId)}`)
  },
}
